import styled from "styled-components";
import {
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography
} from "@material-ui/core";


export const STGrid = styled(Grid)`
    padding: 3px;
`;

export const STCard = styled(Card)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: none;
    margin: 3px;

    :hover, :active{
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);
    }
  }
`;

export const STCardActionArea = styled(CardActionArea)`
  && {
    height: inherit;
  }
`;

export const STTypography = styled(Typography)`
  && {
    font-size: 0.72rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
  }
`;

export const STCardMedia = styled(CardMedia)`
  && {
    height: 48px;
    width: 48px;
    margin: 0 auto;
  }
`;

export const STCardContent = styled(CardContent)`
  && {
    padding: 5px;
  }
`;
